import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Typography from '@material-ui/core/Typography';
import { switchAccountType } from '../../../init/initActions';

import { Title } from '../style';

const AccountType = ({
  currentAccountInformations,
  dispatchSwitchAccountType
}) => {
  const [value, setValue] = useState('particular');
  const {
    accountType,
    individualToken,
    professionalToken
  } = currentAccountInformations;

  useEffect(() => {
    setValue(accountType);
  }, [accountType]);

  const handleChange = event => {
    setValue(event.target.value);
  };

  const updateAccountType = () => {
    if (value === 'professional') {
      dispatchSwitchAccountType(professionalToken, value);
    } else {
      dispatchSwitchAccountType(individualToken, value);
    }
  };
  return (
    <div>
      <Title>Type de compte</Title>
      {currentAccountInformations.userHasTwoAccounts && (
        <Typography variant="subtitle2" gutterBottom>
          Vous possédez un compte professionel et un compte particulier par
          défaut vous êtes connecter à votre compte professionel, vous pouvez
          change de compte dans cette section
        </Typography>
      )}
      {!currentAccountInformations.userHasTwoAccounts && (
        <Typography variant="subtitle2" gutterBottom>
          Vous possédez uniquement un compte{' '}
          {accountType === 'particular' ? 'Particulier' : 'Professionel'}
        </Typography>
      )}
      <div>
        <FormControl component="fieldset" style={{ marginTop: 30 }}>
          <FormLabel component="legend" style={{ marginBottom: 20 }}>
            Type de compte
          </FormLabel>
          <RadioGroup
            aria-label="account type"
            name="accountType"
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              flexDirection: 'row'
            }}
            value={value}
            onChange={handleChange}
          >
            <FormControlLabel
              value="particular"
              control={<Radio color="primary" />}
              label="Particulier"
              disabled={!currentAccountInformations.userHasTwoAccounts}
            />
            <FormControlLabel
              value="professional"
              control={<Radio color="primary" />}
              label="Professionel"
              disabled={!currentAccountInformations.userHasTwoAccounts}
            />
          </RadioGroup>
          <div style={{ textAlign: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 30 }}
              onClick={updateAccountType}
            >
              Mettre à jour
            </Button>
          </div>
        </FormControl>
      </div>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchSwitchAccountType: (token, accountType) =>
    dispatch(switchAccountType(token, accountType))
});

const mapStateToProps = state => ({
  currentAccountInformations: state.init.currentAccountInformations
});

AccountType.propTypes = {
  currentAccountInformations: PropTypes.object.isRequired,
  dispatchSwitchAccountType: PropTypes.func.isRequired
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AccountType);
